import React, { useState } from 'react'
import { Helmet } from 'react-helmet-async';
import BreadcrumbBack from '../../../../../components/breadcrumb/BreadcrumbBack';
import CustomButton from '../../../../../components/button/CustomButton';
import Models from '../../../../../components/models/Models';
import GumletAccountCE from './GumletAccountCE';
import MUITableGrid from '../../../../../components/tables/MUITableGrid';

export default function GumletAccount() {
    const [open, setOpen] = useState(false);
  return (
    <>
    <Helmet>
            <title>{`Gumlet  Account  | ${window.location.hostname}`}</title>
          </Helmet>
           <BreadcrumbBack title="Manage Gumlet Account">
                  <CustomButton
                    title="Create Gumlet Account"
                    icon={true}
                    iconName="create"
                    onClick={() => setOpen(!open)}
                  />
                </BreadcrumbBack>
                      <div className="my-2">
                            <MUITableGrid name="adminGumletAccount" />
                          </div>
                 <Models name="Create New Account" isOpen={open} isClose={setOpen}>
                        <GumletAccountCE type="create" isOpen={setOpen} />
                      </Models>
    </>
  )
}
